import { addStyles } from 'ethcss'
import { IStyles, colors } from 'theme'

const deviceTerminalStyles: IStyles = {
    monitorWindow: {
        position: 'fixed',
        width: 600,
        height: 400,
        background: '#141414',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: '10px',
        overflow: 'hidden',
        zIndex: 2001,
        color: colors.white,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${colors.greyLight}`,
        padding: 24,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
    },
    action: {
        marginLeft: 20,
    },
    downloadLog: {
        padding: 7,
        backgroundColor: colors.greyLight,
        borderRadius: 3,
    },
    content: {
        position: 'relative',
        height: 'calc(100% - 164px)',
        opacity: 1,
        transition: 'opacity 0.2s',
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    noDraggable: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    hidden: {
        opacity: 0,
    },
    resizer: {
        position: 'absolute',
    },
    resizer_r: {
        cursor: 'col-resize',
        height: '100%',
        right: 0,
        top: 0,
        width: '5px',
    },
    resizer_t: {
        cursor: 'row-resize',
        height: '5px',
        left: 0,
        top: 0,
        width: '100%',
    },
    resizer_b: {
        cursor: 'row-resize',
        height: '5px',
        left: 0,
        bottom: 0,
        width: '100%',
    },
    resizer_l: {
        cursor: 'col-resize',
        height: '100%',
        left: 0,
        top: 0,
        width: '5px',
    },
    title: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    menuItem__text: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    scroll: {
        maxHeight: '100%',
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    bottomPanel: {
        padding: 20,
        borderTop: `1px solid ${colors.greyLight}`,
    },
    directory: {
        color: colors.grey,
        marginBottom: 8,
        minHeight: 14,
        textAlign: 'left',
    },
    commandInput: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    form: {
        width: 'calc(100% - 120px)',
    },
    input: {
        width: '100%',
    },
    textArea: {
        width: '100%',
        height: '100%',
        border: 'none',
        background: 'none',
        color: colors.white,
        padding: '20px !important',
    },
}

addStyles(deviceTerminalStyles)
export default deviceTerminalStyles
